import React, { useContext } from "react";

import AnswersContext from "../contexts/AnswersContext";
import useQuestion from "../hooks/useQuestion";

const QuestionBadge = ({ questionID }) => {
  const { getAnswer } = useContext(AnswersContext);
  const { question } = useQuestion({ questionID });
  const answer = getAnswer(questionID);
  const correctAnswer = question.answer;

  const hasCorrectAnswer = answer && answer === correctAnswer;
  const hasIncorrectAnswer = answer && answer !== correctAnswer;

  return (
    <>
      {hasCorrectAnswer && (
        <span
          aria-label="Correct answer."
          className="badge bg-success float-end font-monospace"
        >
          &#x2714;&#xFE0E;
        </span>
      )}
      {hasIncorrectAnswer && (
        <span
          aria-label="Incorrect answer."
          className="badge bg-danger float-end font-monospace"
        >
          &#x2718;&#xFE0E;
        </span>
      )}
    </>
  );
};

export default QuestionBadge;
